<template>
  <grafmonumenten />
</template>

<script>
import Grafmonumenten from '../components/KeuzesUitvaart/Grafmonumenten.vue'

export default {
  name: 'GrafmonumentenView',
  components: {
    Grafmonumenten
  }
}
</script>
